import { Printer } from 'lucide-react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { WORSHIP_SLOTS } from './SundayWorshipSection';

const FONT = { fontFamily: "'Crimson Text', Georgia, serif" };

export const PrintSetlistDialog = ({ open, onClose, worshipSongs }) => (
  <Dialog open={open} onOpenChange={o => !o && onClose()}>
    <DialogContent className="sm:max-w-3xl max-h-[90vh] overflow-y-auto" data-testid="setlist-dialog">
      <DialogHeader className="print:hidden">
        <DialogTitle className="text-xl text-blue-800">Sunday Worship Setlist</DialogTitle>
      </DialogHeader>
      <div id="setlist-printable" className="py-2">
        <div className="text-center mb-6 border-b-2 border-blue-200 pb-4">
          <h1 className="text-3xl font-bold text-blue-900" style={FONT}>True Love Missionary Baptist Church</h1>
          <h2 className="text-xl text-yellow-700 font-semibold mt-1" style={FONT}>Sunday Worship Setlist</h2>
          <p className="text-blue-600 text-sm mt-1" style={FONT}>{new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</p>
        </div>
        {WORSHIP_SLOTS.map((label, i) => {
          const song = worshipSongs[i];
          return (
          <div key={label} className="mb-6 pb-4 border-b border-blue-100 last:border-0 break-inside-avoid">
            <div className="flex items-baseline gap-3 mb-1">
              <span className="text-yellow-600 font-bold text-base" style={FONT}>{label}:</span>
              {song ? (
                <>
                  <h3 className="text-xl font-bold text-blue-900" style={FONT}>{song.title}</h3>
                  {song.song_key && <span className="text-yellow-700 font-semibold text-sm" style={FONT}>Key: {song.song_key}</span>}
                </>
              ) : (
                <span className="text-blue-300 italic" style={FONT}>—</span>
              )}
            </div>
            {song?.author && <p className="text-blue-600 text-sm ml-8 mb-2" style={FONT}>By {song.author}</p>}
            {song?.lyrics && (
              <pre className="whitespace-pre-wrap text-blue-900 text-sm leading-relaxed ml-8" style={FONT}>{song.lyrics}</pre>
            )}
          </div>
          );
        })}
      </div>
      <DialogFooter className="print:hidden">
        <Button onClick={() => {
          const sourceEl = document.getElementById('setlist-printable');
          const printWindow = window.open('', '_blank');
          const doc = printWindow.document;
          doc.open();
          doc.write([
            '<html><head><title>Setlist</title>',
            '<style>',
            "body { font-family: 'Georgia', serif; padding: 24px; color: #1e3a5f; }",
            'h1 { font-size: 24px; font-weight: bold; text-align: center; margin-bottom: 4px; }',
            'h2 { font-size: 18px; text-align: center; color: #a16207; margin-bottom: 4px; }',
            'h3 { font-size: 16px; font-weight: bold; display: inline; }',
            "pre { white-space: pre-wrap; font-family: 'Georgia', serif; font-size: 13px; line-height: 1.6; margin: 4px 0 0 32px; }",
            '.mb-6 { margin-bottom: 20px; padding-bottom: 12px; border-bottom: 1px solid #dbeafe; }',
            '.mb-6:last-child { border-bottom: none; }',
            'p { margin: 2px 0; }',
            '@media print { body { padding: 12px; } }',
            '</style></head><body></body></html>',
          ].join('\n'));
          doc.close();
          doc.body.appendChild(sourceEl.cloneNode(true));
          printWindow.print();
        }} className="bg-blue-700 hover:bg-blue-800 text-white font-bold" style={FONT} data-testid="print-btn">
          <Printer className="h-4 w-4 mr-2" /> Print
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
